export default __webpack_public_path__ + "static/media/ico_wear.c96a2ae0.svg";